import { defineMessages, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { openLoans } from '../../../../actions/homeowner'
import { selectCurrentCELs } from '../../../../store/selectors/home/loans'
import { Text, Form, Button, Heading } from '@homebot/shared-ui-swashbuckle'

export interface PmiEstimatedMortgagesStepProps {
  setInProgress: (inProgress: boolean) => void
}

export const MSG = defineMessages({
  thanksForTuning: {
    id: 'Pmi.Estimated.thanksForTuning',
    defaultMessage: 'Thanks for tuning your Homebot',
  },
  youCanUpdate: {
    id: 'Pmi.Estimated.youCanUpdate',
    defaultMessage:
      'You can update your details at any time from “Your Current Mortgages”',
  },
  viewCurrentMortgages: {
    id: 'PMI.estimated.view.current.mortgages',
    defaultMessage:
      'View your {currentLoans, plural, one {mortgage} other {mortgages}}',
  },
})

export const PmiEstimatedMortgagesStep = ({
  setInProgress,
}: PmiEstimatedMortgagesStepProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const currentLoans = useSelector(selectCurrentCELs)

  const handleSubmit = () => {
    setInProgress(false)
    dispatch(openLoans())
  }

  return (
    <>
      <Heading as='h4' size='sm'>
        {intl.formatMessage(MSG.thanksForTuning)}
      </Heading>
      <Text marginTop='spacing-100' size='md'>
        {intl.formatMessage(MSG.youCanUpdate)}
      </Text>
      <Form onSubmit={handleSubmit}>
        <Button
          type='submit'
          marginTop='spacing-600'
          colorScheme='btn-secondary'
          width={['100%', null, 'inherit']}
        >
          {intl.formatMessage(MSG.viewCurrentMortgages, {
            currentLoans: currentLoans.length,
          })}
        </Button>
      </Form>
    </>
  )
}
